export default "__VITE_ASSET__DDcoCjJ6__"